<template>
  <section>
    <notifications></notifications>

    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />
    <base-header>
      <div class="row align-items-center pt-header">
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-12 alinmov3">
          <div class="box-buttons"></div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 alinmov2 align-self-center"
          >
            <div>
              <div class="box-buttons"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          ></div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-1 text-right"
          >
            <div
              class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block mb-xl-0 mb-1"
            >
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-2"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    @change="applySortBy"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2 mb-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mb-2">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <pagination-block
          :pageCount="cars.pages"
          v-model="currentPage"
          :total="cars.count"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          position="bottom"
        ></pagination-block>
        <b-table
          hover
          :items="cars.docs"
          :fields="fields"
          sort-by.sync="label"
          sort-asc.sync="true"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          responsive
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :stacked="cardview"
        >
          <template #cell(img)="data">
            <img
              :src="`${imageUrl}/vehicles/${data.item.slug}.png`"
              class="img-fluid es-img-service-2"
              alt="Service Car"
            />
          </template>

          <template #cell(label)="data">
            <router-link
              :to="`/tools/vehicles-gallery/upload-photos/${data.item.slug}`"
              class=""
            >
              <div class="content">
                <span class="username hide-data"> {{ data.item.label }}</span>
              </div>
            </router-link>
          </template>

          <template #cell(type)="data">
            <span class="hide-data capitalize">{{
              showType(data.item.type)
            }}</span>
          </template>
          <template #cell(make)="data">
            <span class="hide-data capitalize">{{ data.item.make_label }}</span>
          </template>
          <template #cell(model)="data">
            <span class="hide-data capitalize">{{
              data.item.model_label
            }}</span>
          </template>
          <template #cell(photos)="data">
            <span
              class="hide-data capitalize"
              v-if="data.item.pictures.length > 0"
              >{{ data.item.pictures.length }}</span
            >
            <div class="badge-status status-rejected" v-else>Pending</div>
          </template>

          <template #cell(actions)="data">
            <el-tooltip content="Upload photos" placement="bottom">
              <router-link
                class="icon-action text-blue"
                :to="`/tools/vehicles-gallery/upload-photos${data.item.slug}`"
              >
                <i class="flaticon-up-2 text-primary"></i>
              </router-link>
            </el-tooltip>
          </template>
        </b-table>

        <pagination-block
          :pageCount="cars.pages"
          v-model="currentPage"
          :total="cars.count"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          position="bottom"
        ></pagination-block>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import { DocumentsAPI } from "../../../../../core/api";
import { goBack } from "../../../../../helpers/commons.helpers";
import { IMAGE_BASE_URL } from "../../../../../core/config/env";
export default {
  name: "VehiclesGallery",

  data() {
    return {
      selectedRows: [],
      currentPage: 1,
      vehicleTypes: [
        { label: "Boats", value: "boat" },
        { label: "Coach", value: "coach" },
        { label: "Limousine", value: "limousine" },
        { label: "Minibus", value: "minibus" },
        { label: "MidiCoach", value: "midicoach" },
        { label: "Minivan", value: "minivan" },
        { label: "MPV", value: "mpv" },
        { label: "Pickup", value: "pickup" },
        { label: "Premium Sedans", value: "premium_sedans" },
        { label: "SUVs", value: "suvs" },
        { label: "Sedan", value: "sedan" }
      ],
      fields: [
        {
          key: "img",
          label: "",
          sortable: false,
          thStyle: { minWidth: "20px" },
          class: "text-left"
        },
        {
          key: "label",
          label: "Name",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "text-left"
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "text-center"
        },

        {
          key: "make",
          label: "Make",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "text-center"
        },

        {
          key: "model",
          label: "Model",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "text-center"
        },

        {
          key: "photos",
          label: "Photos",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "alinmov6",
          thStyle: { minWidth: "80px" }
        }
      ],
      cardview: false,
      selected: [],
      limit: 0,
      simpleSearch: "",
      query: "",
      sortBy: "",
      sortDesc: "asc",
      sortDirection: "asc",
      sortOptions: [
        { value: "label", text: "Name" },
        { value: "make", text: "Make" },
        { value: "model", text: "Model" }
      ],
      timeoutId: null,
      category: "",
      imageUrl: IMAGE_BASE_URL,
      view: "table",
      guides: [],
      loader: false,
      visibleSideBar: false
    };
  },
  async mounted() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Tools",
        to: "/tools"
      },

      {
        text: "Vehicle Gallery",
        active: true
      }
    ];
    this.setItemsBread(bread);
  },
  async created() {
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.currentPage = this.carSearchCriteria.currentPage;
    this.query = this.carSearchCriteria.query;
    this.initializeFilterData(this.query);
    this.get(true, this.limit, this.currentPage, this.query);
  },
  methods: {
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value ? value.trim() : value);
      } else {
        searchParams.append(key, value ? value.trim() : value);
      }
      return searchParams.toString();
    },
    applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        if (value) {
          this.query = this.addElementInQuery(this.query, "search", value);
          this.get(true, this.limit, 1, this.query);
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          this.get(true, this.limit, 1, this.query);
        }
      }, 500);
    },
    typeSearch(category) {
      this.category = category;
      if (category !== "all") {
        this.query = this.addElementInQuery(this.query, "category", category);
        this.get(true, this.limit, 1, this.query);
      } else {
        this.query = this.deleteItemInQuery(this.query, ["category"]);
        this.get(true, this.limit, 1, this.query);
      }
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    viewCard() {
      if (this.cardview === true) {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async get(loader, limit, page, query) {
      this.getCars({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
      this.setCarSearchCriteria({
        currentPage: page,
        limit: limit,
        query: query,
        status: true
      });
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    previousPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    nextPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    changePage(page) {
      this.get(true, this.limit, page, this.query);
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    showType(type) {
      let car = this.vehicleTypes.find(element => element.value === type);
      return car ? car.label : "";
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    initializeFilterData(query) {
      let searchCriteria = new URLSearchParams(query);
      this.simpleSearch = searchCriteria.has("search")
        ? searchCriteria.get("search")
        : "";
    },
    isInVehicleGalleryModule(modules = []) {
      if (!(modules.indexOf("vehicles-gallery") > -1)) {
        this.setCarSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments(
        "INTERNAL",
        "VEHICLES_GALLERY"
      );
      this.loader = false;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await DocumentsAPI.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    ...mapMutations(["setLoad", "setItemsBread", "setCarSearchCriteria"]),
    ...mapActions(["getCars", "getLimit"])
  },
  computed: {
    ...mapGetters([
      "sesion",
      "sigout",
      "paginationLimit",
      "cars",
      "carSearchCriteria"
    ])
  },
  filters: {},
  destroyed() {
    clearTimeout(this.timeoutId);
  },
  beforeRouteLeave(to, from, next) {
    this.isInVehicleGalleryModule(to.meta.modules);
    next();
  }
};
</script>
